import { defineMessage } from "react-intl";
import { FEATURE_TAGS } from "../witadmin/Common/constants";
import { Message } from "./i18n";

/**
 * Human-readable label for every `FEATURE_TAGS` key, so the reservations `tags` filter and the
 * Functionality Report filter stop rendering raw object keys.
 *
 * The `Record<keyof typeof FEATURE_TAGS, Message>` type makes this map exhaustive: adding a
 * future `FEATURE_TAGS` key without a message here is a compile error.
 */
export const FEATURE_TAG_MESSAGES: Record<keyof typeof FEATURE_TAGS, Message> = {
  waiting_list: defineMessage({
    id: "reservations.featureTag.waitingList",
    defaultMessage: "Waiting list",
  }),
  combined_rate: defineMessage({
    id: "reservations.featureTag.combinedRate",
    defaultMessage: "Combined rate",
  }),
  bundling_units: defineMessage({
    id: "reservations.featureTag.bundlingUnits",
    defaultMessage: "Bundling units",
  }),
  dynamic_packages: defineMessage({
    id: "reservations.featureTag.dynamicPackages",
    defaultMessage: "Dynamic packages",
  }),
  cart_abandonment_session: defineMessage({
    id: "reservations.featureTag.cartAbandonment",
    defaultMessage: "Cart abandonment",
  }),
  shared_cart: defineMessage({
    id: "reservations.featureTag.sharedCart",
    defaultMessage: "Shared cart",
  }),
  assisted_booking: defineMessage({
    id: "reservations.featureTag.assistedBooking",
    defaultMessage: "Assisted booking",
  }),
  quotation: defineMessage({
    id: "reservations.featureTag.quotation",
    defaultMessage: "Quotation",
  }),
  book_and_join: defineMessage({
    id: "reservations.featureTag.bookAndJoin",
    defaultMessage: "Book and join",
  }),
  split_stay: defineMessage({
    id: "reservations.featureTag.splitStay",
    defaultMessage: "Split stay",
  }),
  upgrade: defineMessage({
    id: "reservations.featureTag.upgrade",
    defaultMessage: "Upgrade",
  }),
  group_module: defineMessage({
    id: "reservations.featureTag.groupModule",
    defaultMessage: "Group booking",
  }),
  inactivity_modal: defineMessage({
    id: "reservations.featureTag.inactivityModal",
    defaultMessage: "Inactivity modal",
  }),
  flight_hotel: defineMessage({
    id: "reservations.featureTag.flightHotel",
    defaultMessage: "Flight + Hotel",
  }),
};
